import { useTheme } from '../ThemeContext';
import TeamManagement from './TeamManagement';

const profile = {
  id: 'owner-1',
  team_id: 'team-1',
  is_team_owner: true,
  role: 'owner',
  first_name: 'Ada',
  last_name: 'Owner',
  subscription_plan: 'team',
  stripe_customer_id: 'cus_owner',
};

const payload = {
  team: { id: 'team-1', name: 'Harbor Realty Group', current_seats: 2, max_seats: 4 },
  members: [
    { id: 'owner-1', first_name: 'Ada', last_name: 'Owner', email: 'ada.owner@harborrealty.example', is_team_owner: true },
    { id: 'member-2', first_name: 'Sam', last_name: 'Lee', email: 'sam.lee.very.long.address@harborrealty.example', is_team_owner: false },
  ],
  invites: [{
    id: 'invite-1',
    email: 'patricia.nguyen.inspections@harborrealty.example',
    first_name: 'Patricia',
    last_name: 'Nguyen',
    invite_code: 'AB12CD34',
    expires_at: '2026-11-14T00:00:00Z',
  }, {
    id: 'invite-2',
    email: 'jordan.ellis.roofing.partner@harborrealty.example',
    first_name: 'Jordan',
    last_name: 'Ellis',
    invite_code: 'CD34EF56',
    expires_at: '2026-12-01T00:00:00Z',
  }],
};

if (typeof window !== 'undefined') {
  window.fetch = (url, options) => {
    if (String(url).includes('manage-team')) {
      return Promise.resolve({ ok: true, json: async () => payload });
    }
    return Promise.resolve({ ok: false, json: async () => ({}) });
  };
}

/**
 * Dev-only Team settings screen. Production builds never mount this.
 */
export default function TeamSettingsPreview() {
  const { colors } = useTheme();

  return (
    <div style={{ background: colors.background, color: colors.text, minHeight: '100%' }}>
      <TeamManagement profile={profile} />
    </div>
  );
}
